import { render } from "./ListeChambre.vue?vue&type=template&id=3be2300c"
import script from "./ListeChambre.vue?vue&type=script&lang=js"
export * from "./ListeChambre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__